import { useCallback } from 'react';

import {
  useCookiesSettings,
  SettingsType,
} from 'app/providers/CookiesSettingsProvider';
import { ContentSt, CookieDashboardContentSt } from '../CookieDashboard.css';
import { SingleCookieSetting } from '../SingleCookieSetting/SingleCookieSetting';
import { cookieSettingsContent } from './cookieSettingsContent';
import { Button } from 'app/shared/components/Button/Button';
import { CookieTitleSt } from './CookieSettings.css';
import { useTranslate } from 'app/shared/components/Translation/hooks/useTranslate/useTranslate';

interface Props {
  onSave?: () => void;
}

const CookieSettings = ({ onSave }: Props) => {
  const {
    setPersonal,
    setMarketing,
    hasSavedCookieSettings,
    saveCookieSettings,
  } = useCookiesSettings();
  const translate = useTranslate();

  const handleToggle = useCallback((type, value) => {
    if (type === SettingsType.personal) {
      setPersonal(value);
    }

    if (type === SettingsType.marketing) {
      setMarketing(value);
    }

    if (!hasSavedCookieSettings) {
      saveCookieSettings(true);
    }
  }, []);

  return (
    <CookieDashboardContentSt>
      <CookieTitleSt as="h2" mt={[32, 0]} mb={40}>
        {translate({
          id: 'containers.cookieDashboard.cookieSettings.mainTitle',
        })}
      </CookieTitleSt>

      <ContentSt>
        <p>
          {translate({
            id: 'containers.cookieDashboard.cookieSettings.mainContent-v2',
          })}
        </p>
      </ContentSt>

      <Button onClick={onSave} color="primary">
        {translate({
          id: 'containers.cookieDashboard.cookieSettings.saveAndContinue',
        })}
      </Button>

      {cookieSettingsContent.map((content, index) => (
        <SingleCookieSetting
          key={index}
          cookieContent={content}
          onToggle={handleToggle}
        />
      ))}

      <ContentSt>
        <p>
          {translate({
            id: 'containers.cookieDashboard.cookieSettings.footerContent-v2',
          })}
        </p>
      </ContentSt>

      <Button onClick={onSave} color="primary">
        {translate({
          id: 'containers.cookieDashboard.cookieSettings.saveAndContinue',
        })}
      </Button>
    </CookieDashboardContentSt>
  );
};

export { CookieSettings };
